import { useParams } from 'react-router';

export const useIsNew = () => {
  const params = useParams();
  if('id' in params) {
    return params.id === 'new';
  }
  return false;
}
